
import {
  defineComponent,
} from 'vue';

export default defineComponent({
  props: {
    columns: {
      type: String,
      required: false,
      default: '2',
    },
    spacer: {
      type: String,
      required: false,
      default: () => 'none',
    },
    spacerCloudsPlacement: {
      type: String,
      required: false,
      default: () => 'bottom',
    },
    spacerBarAlign: {
      type: String,
      required: false,
      default: () => 'right',
    },
  },
});
